import * as React from "react"
import Popper from "@mui/material/Popper"
import Typography from "@mui/material/Typography"
import Fade from "@mui/material/Fade"
import Paper from "@mui/material/Paper"
import {
  Avatar,
  Box,
  ClickAwayListener,
  IconButton,
  useTheme,
} from "@mui/material"
import { styles } from "./styles"
import { useTranslation } from "react-i18next"
import Translator from "./Translator"
import { images } from "utils/images"
import { useModuleContext } from "contexts/ModuleContext"
import useApi from "modules/translator"
import { useAuthContext } from "contexts/AuthContext"
import { useSearchParams } from "react-router-dom"
import { ACTIVITY_VIEW_MODES } from "pages/student/activity/common/constants"

export default function TypographyTranslator({
  open = false,
  selectionText = "",
  anchorEl = null,
  setOpen,
  children,
  onTranslatorOpen = () => {},
  disabled = false,
  ...props
}) {
  const [queryParams] = useSearchParams()
  const { module } = useModuleContext()
  const { selectedGroupData } = useAuthContext()
  const [translationOpen, setTranslationOpen] = React.useState(false)
  const { i18n } = useTranslation()
  const { AVALIALBE_LANGUAGES } = useApi()
  const [fromLanguage, setFromLanguage] = React.useState("en")
  const [toLanguage, setToLanguage] = React.useState("fr")
  const [enabled, setEnabled] = React.useState(false)
  const theme = useTheme()

  React.useEffect(() => {
    if (disabled) {
      setEnabled(false)
      return
    }
    if (selectedGroupData?.groupId > 0) {
      setEnabled(selectedGroupData?.allowStudentsTranslation)
      console.log(
        `allowStudentsTranslation: ${selectedGroupData?.allowStudentsTranslation}`
      )
    } else {
      const viewMode = parseInt(queryParams.get("view")) || 0
      setEnabled(
        viewMode === ACTIVITY_VIEW_MODES.TEACHER_MODULE_BASE ||
          viewMode === ACTIVITY_VIEW_MODES.TEACHER_ACTIVITY_BASE
      )
    }
  }, [selectedGroupData])

  React.useEffect(() => {
    if (selectionText?.trim()?.length === 0) {
      closeTranslation()
    }
  }, [selectionText])

  React.useEffect(() => {
    // get current language
    const currentLanguage = i18n.language
    if (currentLanguage) {
      const to = currentLanguage
      const template = module?.templateLanguageId
      setToLanguage(to)
      if (template) {
        const from = AVALIALBE_LANGUAGES.find(
          (lang) => lang.languageId === template
        )?.code
        setFromLanguage(from)
      } else {
        const from = AVALIALBE_LANGUAGES.find(
          (lang) => lang.languageId === selectedGroupData?.learningLanguageId
        )?.code
        setFromLanguage(from || "en-US")
      }
    }
  }, [module, selectedGroupData?.mainLanguage])

  const openTranslation = () => {
    if (
      selectionText?.trim()?.length === 0 ||
      typeof selectionText !== "string"
    ) {
      closeTranslation()
      return
    }
    setTranslationOpen(true)
    onTranslatorOpen()
  }

  const closeTranslation = (evt) => {
    // console.log("closeTranslation")
    evt?.stopPropagation()
    setOpen(false)
    setTranslationOpen(false)
  }

  const id = open ? "virtual-element-popper" : undefined
  // console.log("TypographyTranslator", { selectionText, open, enabled })
  if (!enabled) return <Typography {...props}>{children}</Typography>

  return (
    <Box className={"translator-typo-content"}>
      <Popper
        id={`id-${id}`}
        open={selectionText?.trim()?.length > 0 && translationOpen && enabled}
        anchorEl={selectionText?.trim()?.length > 0 ? anchorEl : null}
        onClose={closeTranslation}
        className={"translator-typo-content"}
        transition
        sx={styles.popover}
        placement="bottom-start"
        modifiers={[
          {
            name: "arrow",
            enabled: true,
            options: {
              element: "[data-popper-arrow]",
            },
          },
        ]}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps}>
            <Paper
              className={"translator-typo-content"}
              sx={[
                styles.popoverContent,
                {
                  px: 2,
                  py: 1,
                  mt: 1,
                  border: `1px solid ${theme.palette.hover.main}`,
                },
              ]}
            >
              <Translator
                text={selectionText}
                from={fromLanguage}
                to={toLanguage}
                onClose={closeTranslation}
                open={translationOpen}
              />
            </Paper>
          </Fade>
        )}
      </Popper>
      <Popper
        id={id}
        className={"translator-typo-content"}
        open={
          selectionText?.trim()?.length > 0 &&
          open &&
          enabled &&
          !translationOpen
        }
        anchorEl={selectionText?.trim()?.length > 0 ? anchorEl : null}
        transition
        placement="bottom-start"
        sx={styles.popover}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps}>
            <Paper
              sx={styles.popoverContent}
              className={"translator-typo-content"}
            >
              {
                // <Typography sx={{ p: 2 }}>{selectionText}</Typography>
              }
              <ClickAwayListener onClickAway={() => setOpen(false)}>
                <IconButton
                  onClick={openTranslation}
                  id={"translator-typo-btn"}
                  className={"translator-typo-content"}
                  sx={styles.translatorBtn}
                >
                  <Avatar
                    id={"translator-typo-avt"}
                    className={"translator-typo-content"}
                    variant="square"
                    sx={styles.avatar}
                    src={images.language2}
                    classes={{ img: "translator-typo-content" }}
                  />
                </IconButton>
              </ClickAwayListener>
            </Paper>
          </Fade>
        )}
      </Popper>
    </Box>
  )
}
